import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom";
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import styles from "../drawer.module.scss";
import { useState } from "react";
import { useToken } from "../../../../hooks/useToken";
import TableChartRoundedIcon from '@mui/icons-material/TableChartRounded';
import {
  WifiOutlined,
  CodeFilled,
  SettingFilled,
  ProfileFilled,
  HomeFilled,
  IdcardFilled,
  LogoutOutlined,
  TableOutlined
} from "@ant-design/icons";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import SpeakerPhoneRoundedIcon from '@mui/icons-material/SpeakerPhoneRounded';
import FileHex from '../../../../assets/hex.png';
import GpsFixedRoundedIcon from '@mui/icons-material/GpsFixedRounded';

export const AdminList = ({ toggleDrawer, openDrawer }) => {
  const [token, { saveToken }] = useToken();
  const [open, setOpen] = useState(sessionStorage.getItem("openDrawer") ? sessionStorage.getItem("openDrawer") : false);

  const handleClick = () => {
    setOpen(!open);
    sessionStorage.setItem("openDrawer", !open);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("valueKanban");
    sessionStorage.removeItem("updateKanban");
    sessionStorage.removeItem("valueKanbanLabel");
    sessionStorage.removeItem("intervalUpatedCards");
    sessionStorage.removeItem("id_update_chart_farm");
    sessionStorage.removeItem("id_interval_sensorChart");
    sessionStorage.removeItem("valueTypeOperationCards");
    sessionStorage.removeItem("valueTypeOperationKanban");
    sessionStorage.removeItem("typeOperationUser");
    sessionStorage.removeItem("openDrawer");
    saveToken(null);
    window.location.href = "/login";
  };

  return (
    <List component="nav">
      <Link className={styles.listLink} to="/" onClick={toggleDrawer}>
        <ListItemButton>
          <ListItemIcon>
            <HomeFilled className={styles.icons} />
          </ListItemIcon>
          <ListItemText className={styles.listItemText} primary="Home" />
        </ListItemButton>
      </Link>
      <Link className={styles.listLink} to="/dataGrid" onClick={toggleDrawer}>
        <ListItemButton>
          <ListItemIcon>
            <TableOutlined className={styles.icons} />
          </ListItemIcon>
          <ListItemText className={styles.listItemText} primary="Tabela" />
        </ListItemButton>
      </Link>
      <Link className={styles.listLink} to="/kanban" onClick={toggleDrawer}>
        <ListItemButton>
          <ListItemIcon>
            <TableChartRoundedIcon
              className={styles.listItemIcon}
              primary="Kanban"
            ></TableChartRoundedIcon>
          </ListItemIcon>
          <ListItemText className={styles.listItemText} primary="Kanban" />
        </ListItemButton>
      </Link>
      <Link className={styles.listLink} to="/users" onClick={toggleDrawer}>
        <ListItemButton>
          <ListItemIcon>
            <PeopleAltRoundedIcon className={styles.drawerToggleIcon} />
          </ListItemIcon>
          <ListItemText className={styles.listItemText} primary="Usuários" />
        </ListItemButton>
      </Link>
      <Link className={styles.listLink} to="/companies" onClick={toggleDrawer}>
        <ListItemButton>
          <ListItemIcon>
            <BusinessRoundedIcon className={styles.drawerToggleIcon} />
          </ListItemIcon>
          <ListItemText className={styles.listItemText} primary="Empresas" />
        </ListItemButton>
      </Link>
      <Link className={styles.listLink} to="/vehicles" onClick={toggleDrawer}>
        <ListItemButton>
          <ListItemIcon>
            <SettingFilled className={styles.icons} />
          </ListItemIcon>
          <ListItemText
            className={styles.listItemText}
            primary="Configurações"
          />
        </ListItemButton>
      </Link>
      <Link className={styles.listLink} to="/drivers" onClick={toggleDrawer}>
        <ListItemButton>
          <ListItemIcon>
            <IdcardFilled className={styles.icons} />
          </ListItemIcon>
          <ListItemText className={styles.listItemText} primary="Motoristas" />
        </ListItemButton>
      </Link>
      <Link className={styles.listLink} to="/suntecRS232" onClick={toggleDrawer}>
        <ListItemButton>
          <ListItemIcon>
            <GpsFixedRoundedIcon className={styles.icons} />
          </ListItemIcon>
          <ListItemText className={styles.listItemText} primary="RS232" />
        </ListItemButton>
      </Link>
      <Link className={styles.listLink} to="/reports" onClick={toggleDrawer}>
        <ListItemButton>
          <ListItemIcon>
            <ProfileFilled className={styles.icons} />
          </ListItemIcon>
          <ListItemText className={styles.listItemText} primary="Relatórios" />
        </ListItemButton>
      </Link>
      <Link className={styles.listLink} to="/trackers" onClick={toggleDrawer}>
        <ListItemButton>
          <ListItemIcon>
            <CodeFilled className={styles.icons} />
          </ListItemIcon>
          <ListItemText className={styles.listItemText} primary="Comandos" />
        </ListItemButton>
      </Link>
      <ListItemButton onClick={handleClick}>
        <ListItemIcon style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <WifiOutlined style={{ fontSize: "22px", color: "#ffffff" }} />
          {openDrawer ? <></> : !open ? <ExpandMore style={{ color: 'white' }} /> : <ExpandLess style={{ color: 'white' }} />}
        </ListItemIcon>
        <ListItemText primary="FOTA" className={styles.listItemText} />
        {!open ? <ExpandMore style={{ color: 'white' }} /> : <ExpandLess style={{ color: 'white' }} />}
      </ListItemButton>
      <Collapse in={open} timeout="auto">
        <List component="div" disablePadding>
          <Link className={styles.iconOta} to="/trackersOta" onClick={toggleDrawer}>
            <ListItemButton sx={{ pl: 3 }}>
              <ListItemIcon style={{ marginLeft: "2px" }}>
                <SpeakerPhoneRoundedIcon style={{ fontSize: "36px", color: "#ffffff" }} />
              </ListItemIcon>
              <ListItemText className={styles.listItemText} primary="Rastreadores OTA" />
            </ListItemButton>
          </Link>
        </List>

        <List component="div" disablePadding>
          <Link className={styles.iconOta} to="/files" onClick={toggleDrawer}>
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <img src={FileHex} alt="Arquivos .hex" style={{ width: "28px", height: "28px", color: "#ffffff" }} />
              </ListItemIcon>
              <ListItemText className={styles.listItemTextFilesHex} primary="Arquivos hex" style={{ marginLeft: '-5px !important' }} />
            </ListItemButton>
          </Link>
        </List>
      </Collapse>
      <Link className={styles.listLink} to="/login" onClick={handleLogout}>
        <ListItemButton>
          <ListItemIcon>
            <LogoutOutlined className={styles.icons} />
          </ListItemIcon>
          <ListItemText className={styles.listItemText} primary="Sair" />
        </ListItemButton>
      </Link>
    </List>
  );
};
